// Stepts for homepage
const hiringSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začíname',
        description: '<b>Na tejto stránke máš prehľad nad všetkými aktuálnymi uchádzačmi. </b>',
        position: 'center',
        showButtons: true,
    },

},
{
    element: ".datatable-top-bar",
    popover: {
        title: '🥳<br>Vďaka timeline máš prehľad nad celým priebehom náborového procesu',
        description: 'Medzi jednotlivými fázami náboru si môžeš preklikávať a <b>prezrieť si uchádzačov, ktorí práve prechádzajú danou fázou náboru.</b> V červenom kruhu <div class="badge badge-timeline-red"><span>3</span></div> vidíš ich celkový počet.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".top-corner-add-button",
    popover: {
        title: ' ',
        description: '<b>Nových uchádzačov </b> môžeš pridať tu.',
        position: 'left',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Prehľad uchádzačov',
        description: 'Ku každému uchádzačovi si môžeš pridávať značky, skúsenosti, ★ hodnotenia a vlastné poznámky.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-hiring",
    popover: {
        title: ' ',
        description: '<b>Vo východiskom stave vidíš všetkých uchádzačov bez ohľadu na pracovnú pozíciu. </b> Na bližšie preskúmanie sa hodí filter podľa pracovnej pozície. Ľahko tak napríklad zistíš, ako prebieha nábor kritickej pozície.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: '💪<br>Pokročilé filtrovanie',
        description: '<b>Takto si môžeš ľahko prezrieť iba uchádzačov, ktorí spĺňajú všetky tvoje kritéria.</b> Napr. iba uchádzači s určitou značkou, ktorých si ohodnotila na 2★. <br><br>Vyhľadávanie ti potom zase pomôže rýchlo nájsť uchádzača podľa mena',
        position: 'bottom',
        showButtons: true,
    },

},

{
    element: ".action-td",
    popover: {
        title: ' ',
        description: '<b>Dokonalý kandidát? ✨</b> Tu ho môžeš rovno poslať do predvýberu. Stačí namiesto "Noví uchádzači" zvoliť "Predvýber".',
        position: 'bottom-right',
        showButtons: true,
    },


},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../hiring?profile=12" target="_blank" title="Více"><img src="/images/guide-hiring-1.png"></a>',
        description: 'Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> si otvoríš všetko o danom uchádzačovi. Tu môžeš čokoľvek editovať, napr. pridať novú poznámku ✍️',
        position: 'bottom-right',
        showButtons: true,
    },
    onNext: () => {
        $('.modal .close').trigger('click');
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚫<br>Hromadné zamietnutie uchádzačov',
        description: '<b>Stačí označiť nezaujímavých uchádzačov,</b> vyplniť obsah správy a Onboardio ju za teba pošle všetkým takto vybraným uchádzačom. <br><br>Text e-mailu si zvolíš podľa seba alebo môžeš použiť tebou predpripravenú šablónu a <b>ušetriť tak veľa času</b> ⏱️<br><br>  <i>Hromadne je možné vykonávať aj ďalšie akcie.</i>',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
// {
//     element: ".align-self-start",
//     popover: {
//         title: ' ',
//         description: 'Kandidátov si môžete pridávať ručne. Väčšie množstvo uchádzačov, napr. od personálne agentúry, je možné do nahrať rovno <b> z dodanej tabuľky (Excel alebo CSV).</b>',
//         position: 'top',
//         showButtons: true,
//     },
//
// },
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Skvelá práca!',
        description: 'Objav svoj archív talentov (1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Áno, pokračovať ďalej',
        nextBtnText: 'Rozumiem',        // Next button text for this step
        prevBtnText: 'Späť',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/talentpool#guide");

    }
},
]



export default hiringSteps
